/* upsell-selector v4 */
(function() {
  'use strict';

  function initWrap(wrap) {
    if (wrap.dataset.upsellInit === '1') return;
    wrap.dataset.upsellInit = '1';

    var opts = wrap.querySelectorAll('.upsell-selector__option');
    opts.forEach(function(o) {
      o.addEventListener('click', function() {
        opts.forEach(function(x) { x.classList.remove('selected'); });
        o.classList.add('selected');
      });
    });

    var mainVariants = [];
    try { mainVariants = JSON.parse(wrap.dataset.mainVariants || '[]'); } catch (e) {}

    function readMainVariantId() {
      var inputs = document.querySelectorAll('input[name="id"], select[name="id"]');
      for (var i = 0; i < inputs.length; i++) {
        var v = parseInt(inputs[i].value, 10);
        if (!isNaN(v)) {
          for (var j = 0; j < mainVariants.length; j++) {
            if (mainVariants[j].id === v) return v;
          }
        }
      }
      try {
        var urlVariant = new URLSearchParams(window.location.search).get('variant');
        if (urlVariant) {
          var pv = parseInt(urlVariant, 10);
          for (var k = 0; k < mainVariants.length; k++) {
            if (mainVariants[k].id === pv) return pv;
          }
        }
      } catch (e) {}
      if (inputs.length > 0) {
        var fv = parseInt(inputs[0].value, 10);
        if (!isNaN(fv)) return fv;
      }
      return null;
    }

    function getMainSelectedOpts() {
      var vid = readMainVariantId();
      if (!vid) return null;
      for (var i = 0; i < mainVariants.length; i++) {
        if (mainVariants[i].id === vid) return mainVariants[i].opts || {};
      }
      return null;
    }

    function resolveUpsellIds(sel) {
      var productsJson = sel ? sel.dataset.upsellProducts : '';
      if (!productsJson) return [];
      var products;
      try { products = JSON.parse(productsJson); } catch (e) { return []; }
      var mainOpts = getMainSelectedOpts() || {};
      return products.map(function(p) {
        var match = null;
        for (var i = 0; i < p.variants.length; i++) {
          var v = p.variants[i];
          var ok = true;
          for (var key in mainOpts) {
            if (Object.prototype.hasOwnProperty.call(v.opts, key) && v.opts[key] !== mainOpts[key]) {
              ok = false; break;
            }
          }
          if (ok) { match = v.id; break; }
        }
        return match || p.fallback;
      });
    }

    function isUpsellSelected() {
      var sel = wrap.querySelector('.upsell-selector__option.selected');
      if (!sel) return false;
      var includeMain = sel.dataset.includeMain !== 'false';
      return !includeMain && !!(sel.dataset.upsellProducts || sel.dataset.upsellIds);
    }

    function getDrawerSectionId() {
      var drawer = document.querySelector('hdt-cart-drawer[section-id]');
      return drawer ? drawer.getAttribute('section-id') : null;
    }

    function refreshDrawerHtml(sectionId, sectionsData) {
      if (!sectionId || !sectionsData) return;
      var newHtml = sectionsData[sectionId];
      if (!newHtml) return;
      var doc = new DOMParser().parseFromString(newHtml, 'text/html');
      var newDrawer = doc.querySelector('hdt-cart-drawer');
      var oldDrawer = document.querySelector('hdt-cart-drawer');
      if (newDrawer && oldDrawer) oldDrawer.replaceWith(newDrawer);
    }

    function openCartDrawer() {
      var drawer = document.querySelector('hdt-cart-drawer');
      if (!drawer) return;
      var dialog = drawer.querySelector('dialog');
      if (dialog && typeof dialog.showModal === 'function') {
        try { dialog.showModal(); return; } catch (e) {}
      }
      if (dialog) { dialog.setAttribute('open', ''); return; }
      var toggleBtn = document.querySelector('[aria-controls="CartDrawer"], [data-cart-drawer-toggle]');
      if (toggleBtn) toggleBtn.click();
    }

    function cartAddBundle(upsellIds) {
      var sectionId = getDrawerSectionId();
      var body = { items: upsellIds.map(function(id) { return { id: id, quantity: 1 }; }) };
      if (sectionId) body.sections = sectionId;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function(r) { return r.json(); }).then(function(data) {
        if (data.sections) refreshDrawerHtml(sectionId, data.sections);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
        document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
        openCartDrawer();
        return data;
      });
    }

    function isProductAddButton(target) {
      if (!target || !target.closest) return null;
      var btn = target.closest('button[type="submit"][name="add"], button[name="add"], [data-add-to-cart]');
      if (btn) return btn;
      var submitBtn = target.closest('button[type="submit"]');
      if (submitBtn && submitBtn.closest('hdt-buy-buttons')) return submitBtn;
      return null;
    }

    document.addEventListener('click', function(e) {
      if (!isUpsellSelected()) return;
      var btn = isProductAddButton(e.target);
      if (!btn) return;
      var sel = wrap.querySelector('.upsell-selector__option.selected');
      var upsellIds = resolveUpsellIds(sel);
      if (!upsellIds || upsellIds.length === 0) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      cartAddBundle(upsellIds);
    }, true);
  }

  function init() {
    document.querySelectorAll('.upsell-selector').forEach(initWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
